// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;


const navConfig = [

  {
    title: 'Applications',
    path: '/dashboard/applications',
    icon: icon('ic_user'),
  },

];

const navAdminConfig = [

  {
    title: 'Applications',
    path: '/dashboard/applications',
    icon: icon('ic_user'),
  },
  {
    title: 'Manage Clients',
    path: '/dashboard/admin',
    icon: icon('ic_admin'),
  },
];

export { navConfig, navAdminConfig };
